module.exports = __webpack_public_path__ + "static/img/envelope01zh-tw.10282df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope01zh-tw.png
// module id = YdtT
// module chunks = 1